import { useQuery } from 'data-fetching-client';
import { useParams } from 'react-router-dom';
import { useGetIsEmbedded } from 'automation-ui-permissions/feature-permissions/hooks/embedHooks';
import { GET_FEATURE_PERMISSIONS, GET_FEATURE_PERMISSIONS_BY_FLOW_ID, GET_EMBED_FEATURE_PERMISSIONS } from 'automation-ui-permissions/feature-permissions/queries/featurePermissionsQueries';
import { getFeaturePermissionAndQuery } from 'automation-ui-permissions/feature-permissions/utils/featurePermissions';
export const useFeaturePermissionQueries = ({
  flowId,
  isEmbedded
}) => {
  const featurePermissionsQuery = useQuery(GET_FEATURE_PERMISSIONS, {
    skip: !!flowId || isEmbedded
  });
  const featurePermissionsByFlowIdQuery = useQuery(GET_FEATURE_PERMISSIONS_BY_FLOW_ID, {
    variables: {
      flowId: flowId
    },
    skip: !flowId || isEmbedded
  });
  const embedFeaturePermissionsQuery = useQuery(GET_EMBED_FEATURE_PERMISSIONS, {
    skip: !isEmbedded
  });
  const loading = featurePermissionsByFlowIdQuery.loading || featurePermissionsQuery.loading || embedFeaturePermissionsQuery.loading;
  const error = !!(featurePermissionsByFlowIdQuery.error || featurePermissionsQuery.error || embedFeaturePermissionsQuery.error);
  return {
    featurePermissionsQuery,
    featurePermissionsByFlowIdQuery,
    embedFeaturePermissionsQuery,
    loading,
    error
  };
};
export const useFeaturePermission = ({
  sourceApp,
  feature,
  featureContext
}) => {
  const {
    flowId
  } = useParams();
  const isEmbedded = useGetIsEmbedded();
  const {
    featurePermissionsQuery,
    featurePermissionsByFlowIdQuery,
    embedFeaturePermissionsQuery
  } = useFeaturePermissionQueries({
    flowId,
    isEmbedded
  });
  return getFeaturePermissionAndQuery(featurePermissionsQuery, featurePermissionsByFlowIdQuery, embedFeaturePermissionsQuery, flowId, isEmbedded, feature, sourceApp, featureContext);
};
export const useGetFeaturePermission = () => {
  const {
    flowId
  } = useParams();
  const isEmbedded = useGetIsEmbedded();
  const {
    featurePermissionsQuery,
    featurePermissionsByFlowIdQuery,
    embedFeaturePermissionsQuery
  } = useFeaturePermissionQueries({
    flowId,
    isEmbedded
  });
  return ({
    sourceApp,
    feature,
    featureContext
  }) => {
    return getFeaturePermissionAndQuery(featurePermissionsQuery, featurePermissionsByFlowIdQuery, embedFeaturePermissionsQuery, flowId, isEmbedded, feature, sourceApp, featureContext);
  };
};